import { AuthStore, createAuthStore } from '@/core/store';
import { createContext, useContext, useRef } from 'react';
import { useStore } from 'zustand';
import { AuthStoreApi, AuthStoreProviderProps } from './AuthStoreProvider.types';

const AuthContext = createContext<AuthStoreApi | null>(null);

export const AuthProvider = ({ children }: AuthStoreProviderProps) => {
   const storeRef = useRef<AuthStoreApi | null>(null);
   if (storeRef.current === null) {
      storeRef.current = createAuthStore();
   }

   return <AuthContext.Provider value={storeRef.current}>{children}</AuthContext.Provider>;
};

export const useAuthStore = <T,>(selector: (store: AuthStore) => T): T => {
   const context = useContext(AuthContext);

   if (!context) {
      throw new Error(`useAuthStore must be used within authStoreProvider`);
   }

   return useStore(context, selector);
};
